import * as Yup from "yup";

export default () => {
  return Yup.object().shape({
    name: Yup.string().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.ADD_A_VALUE_INTO_THE_FIELD"
    )
  });
};
